module.exports = __webpack_public_path__ + "static/media/ci.3befbf7b.svg";